import themeJSON from './theme.json';
import { ChakraTheme, ChakraThemeCategory } from '../types/types';

export const getToken = (
  themeCategory: string,
  tokenName: string,
  themeVariation: 'light' | 'dark' = 'light'
) => {
  const theme = themeJSON as ChakraTheme;

  if (themeCategory === 'colors') {
    const colorCategory = theme[themeCategory] as ChakraThemeCategory;
    return (
      (colorCategory[themeVariation] as { [token: string]: string })?.[
        tokenName
      ] || null
    );
  } else {
    const category = theme[themeCategory] as ChakraThemeCategory | undefined;
    return category?.[tokenName] as string | null;
  }
};

export const getTokenAsString = (
  themeCategory: string,
  tokenName: string,
  themeVariation?: 'light' | 'dark'
) => {
  const value = getToken(themeCategory, tokenName, themeVariation);
  if (typeof value === 'string') {
    return value;
  } else {
    return '';
  }
};

export const getColorToken = (
  tokenName: string,
  themeVariation?: 'light' | 'dark'
) => getTokenAsString('colors', tokenName, themeVariation);

export const getFontFamilyToken = (tokenName: string) =>
  getTokenAsString('fonts', tokenName);

export const getFontSizeToken = (tokenName: string) =>
  getTokenAsString('fontSizes', tokenName);

export const getFontWeightToken = (tokenName: string) =>
  getTokenAsString('fontWeights', tokenName);

export const getLineHeightToken = (tokenName: string) =>
  getTokenAsString('lineHeights', tokenName);

export const getLetterSpacingToken = (tokenName: string) =>
  getTokenAsString('letterSpacings', tokenName);

export const getBorderWidthToken = (tokenName: string) =>
  getTokenAsString('borderWidths', tokenName);

export const getRadiusToken = (tokenName: string) =>
  getTokenAsString('radii', tokenName);

export const getSizeToken = (tokenName: string) =>
  getTokenAsString('sizes', tokenName);

export const getSpaceToken = (tokenName: string) =>
  getTokenAsString('space', tokenName);

export const getShadowToken = (tokenName: string) =>
  getTokenAsString('shadows', tokenName);

export const getTextStyleToken = (tokenName: string): object | null => {
  const value = getToken('textStyles', tokenName);
  if (typeof value === 'object') {
    return value;
  } else {
    return null;
  }
};

export const getTypographyToken = getTextStyleToken;

export const getBoxSizingStyles = () => {
  const baseStyles = {
    borderWidth: 0,
    borderStyle: 'solid',
    boxSizing: 'border-box',
    wordWrap: 'break-word',
  };

  return {
    ...baseStyles,
    _after: { ...baseStyles },
    _before: { ...baseStyles },
  };
};
